class DocumentationFilters {

    constructor() {

        this.filtersOpen = false;
        this.defaultOpenCloseAnimationSpeed = 200;
        this.defaultFadeToAnimationSpeed = 200;
        this.defaultInputSearchMinWidth = 0.35;

    }

    filtersManagement(folderId) {

        const that = this;
        const openFiltersButton = $('#documentation-filters-button-open-' + folderId);
        const closeFiltersButton = $('#documentation-filters-button-close-' + folderId);

        // Si se dibuja una nueva carpeta y los filtros estaban abiertos mantener el estado
        if (this.filtersOpen) {
            this.openFilters(folderId);
        }

        openFiltersButton.off('click.openFilters').on('click.openFilters', function () {
            that.filtersOpen = true;
            that.openFilters(folderId);
        });

        closeFiltersButton.off('click.closeFilters').on('click.closeFilters', function () {
            that.filtersOpen = false;
            that.closeFilters(folderId);
        });

    }

    openFilters(folderId) {

        const openFiltersButton = $('#documentation-filters-button-open-' + folderId);
        const documentationFilters = $('#documentation-filters-bar-' + folderId);
        const searcherContainer = $('.documentation-searcher').last();
        const searcherInput = $('.documentation-searchbar').last();
        const filterContainer = $('.documentation-filters').last();
        const filterElement = $(".documents-filter").last();
        let filtersAnimatonHeight = null;
        let searchInputFreeWidth = null;

        // Al desplegar los filtros se olculta el boton (Icono de buscar) y se muestran los filtros pero sin opacidad (para poder calcular medidas)
        openFiltersButton.hide();
        documentationFilters.show();

        // Se obtienen las medidas para saber si el buscador cabe o no en la misma fila que los filtros.
        searchInputFreeWidth = DocumentationUtils.calculateSearchInputWidth("documentation");

        const searcherHeight = parseInt(searcherInput.css("height")) + parseInt(searcherContainer.css("paddingTop")) + parseInt(searcherContainer.css("paddingBottom"));
        const filtersHeight = parseInt(filterElement.css("height")) + parseInt(filterContainer.css("paddingTop")) + parseInt(filterContainer.css("paddingBottom"));

        // Dependiendo de si el buscador cabe o no en la misma fila la altura de la animacion que baja los filtros es mayor o menor (los filtros estaran en 1 linea o en 2)
        if (searchInputFreeWidth >= $('.wrapper').last().width() * this.defaultInputSearchMinWidth) {
            filtersAnimatonHeight = searcherHeight;
        } else {
            filtersAnimatonHeight = searcherHeight + filtersHeight;
        }

        // Se despliega la cortina donde iran los filtros
        documentationFilters.animate({height: filtersAnimatonHeight}, this.defaultOpenCloseAnimationSpeed);
        // Se hacen opacos con una animacion
        documentationFilters.fadeTo(this.defaultFadeToAnimationSpeed, 1);

    }

    closeFilters(folderId) {

        const openFiltersButton = $('#documentation-filters-button-open-' + folderId);
        const documentationFilters = $('#documentation-filters-bar-' + folderId);

        // Al cerrar los filtros se hace invisible el contenido
        documentationFilters.fadeTo(this.defaultFadeToAnimationSpeed, 0);
        // Y subimos la cortina de nuevo hasta la altura que tenia el boton de mostrar filtros
        documentationFilters.animate({height: openFiltersButton.css('height')}, this.defaultOpenCloseAnimationSpeed, function () {
            documentationFilters.hide();
            openFiltersButton.show();
        });

    }

}